module.exports = __webpack_public_path__ + "static/ServiceNow-d60974e84baa471c92447883a67a0cef.png";